import { createContext } from '$utils/index';

type HeroContext = {
  sectionIndex: number;
  setSectionIndex: (fnNextSection: (prevSection: number) => number) => void;

  currentPage: number;
  setCurrentPage: (fnCurrentPage: (pageNum: number) => number) => void;

  offset: number;
  setOffset: (fnOffset: (pageNum: number) => number) => void;

  fromBG: number;
  setFromBG: (fnFromBG: (bg: number) => number) => void;

  alt: boolean;
  setAlt: (fnAlt: (alt: boolean) => boolean) => void;

  canScroll: boolean;
  setCanScroll: (fnCanScroll: (canScroll: boolean) => boolean) => void;

  firstLoad: boolean;
  setFirstLoad: (fnFirstLoad: (firstLoad: boolean) => boolean) => void;

  currentAnimation: string;
  setCurrentAnimation: (
    fnCurrentAnimation: (currentAnimation: string) => string,
  ) => void;

  currentInnerAnimation: string;
  setCurrentInnerAnimation: (
    fnCurrentInnerAnimation: (currentInnerAnimation: string) => string,
  ) => void;
};

const store = (set): HeroContext => ({
  sectionIndex: 0,
  setSectionIndex: (fnNextSection) => {
    set((state) => ({
      ...state,
      sectionIndex: fnNextSection(state.sectionIndex),
    }));
  },

  currentPage: 0,
  setCurrentPage: (fnCurrentPage) => {
    set((state) => ({
      ...state,
      currentPage: fnCurrentPage(state.currentPage),
    }));
  },

  offset: 0,
  setOffset: (fnOffset) => {
    set((state) => ({
      ...state,
      offset: fnOffset(state.offset),
    }));
  },

  fromBG: -1,
  setFromBG: (fnFromBG) => {
    set((state) => ({
      ...state,
      fromBG: fnFromBG(state.fromBG),
    }));
  },

  alt: false,
  setAlt: (fnAlt) => {
    set((state) => ({
      ...state,
      alt: fnAlt(state.alt),
    }));
  },

  canScroll: true,
  setCanScroll: (fnCanScroll) => {
    set((state) => ({
      ...state,
      canScroll: fnCanScroll(state.canScroll),
    }));
  },

  firstLoad: true,
  setFirstLoad: (fnFirstLoad) => {
    set((state) => ({
      ...state,
      firstLoad: fnFirstLoad(state.firstLoad),
    }));
  },

  currentAnimation: 'none',
  setCurrentAnimation: (fnCurrentAnimation) => {
    set((state) => ({
      ...state,
      currentAnimation: fnCurrentAnimation(state.currentAnimation),
    }));
  },

  currentInnerAnimation: 'none',
  setCurrentInnerAnimation: (fnCurrentInnerAnimation) => {
    set((state) => ({
      ...state,
      currentInnerAnimation: fnCurrentInnerAnimation(
        state.currentInnerAnimation,
      ),
    }));
  },
});

const [HeroContext, HeroProvider] = createContext<HeroContext>(store);

export { HeroContext, HeroProvider };
